import { supabaseClient } from 'supabase'
import { DeskCounts } from './deskTypes'

/**
 * The four tab counts from the admin-only `desk_counts()` RPC (D-03): exact
 * SQL counts, never fetched-row counts (PostgREST caps a select at 1000 rows).
 * The RPC raises 42501 for a non-admin rather than returning zeros, and that
 * error is rethrown unchanged.
 *
 * The bigint columns arrive as JSON numbers; `Number()` keeps the type honest
 * if one ever arrives as a string.
 */
export const queryDeskCounts = async (): Promise<DeskCounts> => {
  const { data, error } = await supabaseClient.rpc('desk_counts')

  if (error) {
    throw error
  }
  const row = Array.isArray(data) ? data[0] : data
  if (!row) {
    // A missing row is not "four zeros": say so instead of showing empty tabs.
    throw new Error('desk_counts returned no row')
  }
  return {
    ready: Number(row.ready),
    needs_a_look: Number(row.needs_a_look),
    discard: Number(row.discard),
    updates: Number(row.updates)
  }
}
